export default "__VITE_ASSET__emr$x$JC__"